module.exports = __webpack_public_path__ + "img/kerlouan.b28fa94e.jpg";